export var FindReplaceActionTypes = /*#__PURE__*/function (FindReplaceActionTypes) {
  FindReplaceActionTypes["ACTIVATE"] = "ACTIVATE";
  FindReplaceActionTypes["FIND"] = "FIND";
  FindReplaceActionTypes["UPDATE_DECORATIONS"] = "UPDATE_DECORATIONS";
  FindReplaceActionTypes["FIND_NEXT"] = "FIND_NEXT";
  FindReplaceActionTypes["FIND_PREVIOUS"] = "FIND_PREVIOUS";
  FindReplaceActionTypes["REPLACE"] = "REPLACE";
  FindReplaceActionTypes["REPLACE_ALL"] = "REPLACE_ALL";
  FindReplaceActionTypes["CANCEL"] = "CANCEL";
  FindReplaceActionTypes["BLUR"] = "BLUR";
  FindReplaceActionTypes["TOGGLE_MATCH_CASE"] = "TOGGLE_MATCH_CASE";
  return FindReplaceActionTypes;
}({});